import { AlertCircle, Check, HelpCircle, X } from "lucide-react"

export enum StatusType {
  GOOD = "good",
  CAUTION = "caution",
  CONCERN = "concern",
  NO_DATA = "no_data",
  BASELINE = "baseline",
}

export const dataByStatusType = {
  [StatusType.GOOD]: {
    icon: Check,
    bgClass: "bg-good",
    textClass: "text-good-foreground",
  },
  [StatusType.CAUTION]: {
    icon: AlertCircle,
    bgClass: "bg-caution",
    textClass: "text-caution-foreground",
  },
  [StatusType.CONCERN]: {
    icon: X,
    bgClass: "bg-bad",
    textClass: "text-bad-foreground",
  },
  [StatusType.NO_DATA]: {
    icon: HelpCircle,
    bgClass: "bg-muted",
    textClass: "text-muted-foreground",
  },
  [StatusType.BASELINE]: {
    icon: Check,
    bgClass: "bg-muted",
    textClass: "text-muted-foreground",
  },
} satisfies Record<
  StatusType,
  { icon: typeof Check; bgClass: string; textClass: string }
>
